import { z } from 'zod/v4';

export const ShareCompanyDocumentParamsSchema = z.object({
  id: z.string().min(1),
});

export type ShareCompanyDocumentParams = z.infer<
  typeof ShareCompanyDocumentParamsSchema
>;

/** The companies to share with — a bare array, as the frontends send it. */
export const ShareCompanyDocumentBodySchema = z.array(z.string().min(1)).min(1);

export type ShareCompanyDocumentBody = z.infer<
  typeof ShareCompanyDocumentBodySchema
>;

/**
 * The companies this call newly gave access to. Left out: the document's owner and
 * the company it is filed on (they already have it), ids that name no company, and
 * companies that already hold an approved share — so an empty list is a valid
 * outcome, not an error.
 */
export const ShareCompanyDocumentResponseSchema = z.object({
  sharedWithCompanyIds: z.array(z.string()),
});

export type ShareCompanyDocumentResponse = z.infer<
  typeof ShareCompanyDocumentResponseSchema
>;
